import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-status-preview',
  templateUrl: './status-preview.component.html',
  styleUrl: './status-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StatusPreviewComponent {
  readonly status = input.required<string>();
  readonly bgColorClass = input<string>('bg-gray-300');
}
